var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"app-card"},[_c('fude-table',{staticClass:"experiences",attrs:{"settings":_vm.settings},scopedSlots:_vm._u([{key:"name",fn:function({ item }){return _c('span',{},[_c('span',[_vm._v(_vm._s(item.name))])])}},{key:"contact",fn:function({ item }){return _c('span',{},[_c('span',[_vm._v(_vm._s(item.contact))])])}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }